import React from "react"
import clsx from "clsx"

import Card from "./_Card"

function WhyPageCards({ title, size, links }) {
  return (
    <section
      data-slice="WhyPageCards"
      className={clsx(
        "wrapper relative default-grid md:gap-y-24 gap-y-10",
        size === "Small" ? "pb-0" : "pb-0 md:pb-16"
      )}
    >
      {title && (
        <h2
          className={clsx(
            "pt-16 h1 col-span-full md:pt-24",
            size === "Small" ? "text-darkPurple" : "text-violet"
          )}
        >
          {title}
        </h2>
      )}
      <ul
        className={clsx(
          "default-grid grid-cols-1 col-span-full md:gap-y-fluidGutter gap-y-px xl:gap-y-8 sm:-mx-fluidMargin -mx-6 md:mx-0",
          size === "Small" ? "md:grid-cols-3" : "md:grid-cols-2"
        )}
      >
        {links.map((link, i) => (
          <Card {...link} size={size} key={`card--${i}`} />
        ))}
      </ul>
    </section>
  )
}

export default WhyPageCards
